import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from '@/lang/en.json'

Vue.use(VueI18n)

const SUPPORTED_LANGUAGES = [
    {'code': 'en', 'flagImg': 'flag_rect_221.png'},
    {'code': 'id', 'flagImg': 'flag_rect_99.png'},
    {'code': 'zh', 'flagImg': 'flag_rect_44.png'}
    // {'code': 'tl', 'flagImg': 'flag_rect_167.png'},
    // {'code': 'vn', 'flagImg': 'flag_rect_228.png'},
    // {'code': 'hi', 'flagImg': 'flag_rect_98.png'},
    // {'code': 'ta', 'flagImg': 'flag_rect_98.png'},
    // {'code': 'bn', 'flagImg': 'flag_rect_18.png'}
]

const i18n = new VueI18n({
    locale: 'en',
    fallbackLocale: 'en',
    messages: { en }
})

const translation = {
    get supportedLanguages () {
        return SUPPORTED_LANGUAGES
    },

    get currentLanguage () {
        return i18n.locale
    },

    set currentLanguage (lang) {
        i18n.locale = lang
    },

    setI18nLanguageInServices (lang) {
        translation.currentLanguage = lang
        // axios.defaults.headers.common['Accept-Language'] = lang
        document.querySelector('html').setAttribute('lang', lang)
        return lang
    },

    /**
     * Loads new translation messages and changes the language when finished
     * @param lang
     * @return {Promise<any>}
     */
    changeLanguage (lang) {
        if (!translation.isLangSupported(lang)) return Promise.reject(new Error('Language not supported'))
        if (i18n.locale === lang) return Promise.resolve(lang) // has been loaded prior
        return translation.loadLanguageFile(lang).then(msgs => {
            i18n.setLocaleMessage(lang, msgs.default || msgs)
            return translation.setI18nLanguageInServices(lang)
        })
    },

    /**
     * Async loads a translation file
     * @param lang
     * @return {Promise<*>|*}
     */
    loadLanguageFile (lang) {
        return import(/* webpackChunkName: "lang-[request]" */ `@/lang/${lang}.json`)
    },

    /**
     * Checks if a lang is supported
     * @param {String} lang
     * @return {boolean}
     */
    isLangSupported (lang) {
        var exists = Object.keys(translation.supportedLanguages).some(function(k) {
            return translation.supportedLanguages[k].code === lang;
        });
        return exists
    },
}

export { i18n, translation }